<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <ul>
            <div class="pci"><img :src="form.url" alt="" width="300px" /></div>
            <div class="name">{{ form.name }}</div>
            <div class="name">{{ form.introduce }}</div>
            <li v-for="item in form.list" :key="item.id" class="li-item">
              <div class="hotel" @click="goToDetail(item)">
                {{ item.hotel }}
              </div>
              <div class="address">地址：{{ item.address }}</div>
              <div class="address">联系电话：{{ item.phone }}</div>
              <div class="hotelIntroduce">{{ item.hotelIntroduce }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      form: {
        url: require("@/assets/images/zhpt.jpg"),
        name: " 服务配套板块",
        introduce: "配套服务板块在各自行业中具有较高品牌知名度。",
        list: [
          {
            id: 1,
            hotel: "天津市津旅旅游汽车有限公司",
            address: "天津市河西区紫金山路36号",
            phone: "022-88376948",
            hotelIntroduce: "旅游用车接待行业的专业客运公司",
          },
          {
            id: 2,
            hotel: "天津津旅物业管理有限公司",
            address: "天津市和平区南京路99号君隆广场",
            phone: "022-27313388",
            hotelIntroduce: "专业化、标准化、人性化的物业管理服务",
          },
          {
            id: 3,
            hotel: "天津北方人才港股份有限公司",
            address: "天津市和平区南京路君隆广场C座8楼",
            phone: "022-23210666",
            hotelIntroduce: "提供专业化人力资源全方位服务",
          },
          {
            id: 4,
            hotel: "天津招商空运代理有限公司",
            address: "暂无",
            phone: "",
            hotelIntroduce:
              "瑞金花园坐落于天津市河西区紫金山路，与五星级大酒店喜来登毗邻，环境优美...",
          },
          {
            id: 5,
            hotel: "天津静海泊泰医院有限公司",
            address: "暂无",
            phone: "",
            hotelIntroduce:
              "康宁津园泊泰医院位于天津市静海县团泊新城西区鄱阳湖路北侧，以健康管理、...",
          },
          {
            id: 6,
            hotel: "康宁津园",
            address: "暂无",
            phone: "",
            hotelIntroduce:
              "天津旅游集团投资建设开发运营的康宁津园新型养老社区，位居中日（天津）健...",
          },
          {
            id: 7,
            hotel: "天津津旅康养职业培训学校有限公司",
            address: "暂无",
            phone: "",
            hotelIntroduce: "天津津旅康养职业培训学校有限公司",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    goToDetail(item) {
      if (item.id == 1) {
        this.$router.push("/lyqc");
      } else if (item.id == 2) {
        this.$router.push("/lywy");
      } else if (item.id == 3) {
        this.$router.push("/bfycg");
      } else if (item.id == 4) {
        this.$router.push("/bfycg");
      } else if (item.id == 5) {
        this.$router.push("/btyy");
      }else if (item.id == 6) {
        this.$router.push("/knjy");
      }else if (item.id ==7) {
        this.$router.push("/jljk");
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 0px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      .pci {
        margin-top: 20px;
        text-align: center;
      }
      .name {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #1c5c88;
        text-align: center;
        margin-top: 15px;
      }
      .hotel {
        cursor: pointer;
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        font-weight: bold;
      }
      .hotel:hover {
        color: red;
        text-decoration: underline;
      }
      .address {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #777;
      }
      .hotelIntroduce {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        color: #2d5b89;
      }
      .li-item {
        text-align: center;
        width: 100%;
        // height: 202px;
        background: #ffffff;
        // border-bottom: 1px solid #e5e5e5;
        padding: 15px 103px 20px 40px;
        box-sizing: border-box;
      }
      .wp_single.wp_column_article {
        padding: 15px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>